import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { FormFields } from '../../../AccountForm.meta';
import { useAccountFormContext } from '../../../context/useAccountFormContext';
import {
  GroupType,
  OptionType,
} from '../../../../../../../../../CommonComponents/OPL/Select/BaseSelect/types';
import { Box } from '../../../../../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../../../../../CommonComponents/OPL/Button/Button';

interface Props {
  index: number;
  label: string;
  allowsUnequalOwnership?: boolean;
  groupOptions: GroupType<OptionType<string>>[];
  onUpdate: (data: { label: string; value: string | null }) => void;
  setCustomised?: () => void;
}

export const OwnershipSelect = ({
  index,
  label,
  allowsUnequalOwnership = false,
  groupOptions,
  onUpdate,
  setCustomised,
}: Props) => {
  const { options: peopleOptions } = groupOptions[0];

  const formBag = useFormContext<FormFields>();
  const {
    control,
    watch,
    formState: { errors },
  } = formBag;

  const [ownerModel] = watch(['bankAccount.OwnerModel']);

  /** Based on Account Type,
   * If unequal ownership cannot be added, then "Joint" option can be shown
   * If unequal ownership can be added and "Customise" button is not clicked, then "Joint" option can be shown
   * If unequal ownership can be added and "Customise" button is clicked, then "Joint" option should be hidden
   */
  const selectedOwners: string[] = allowsUnequalOwnership
    ? !setCustomised
      ? ownerModel.map(owner => owner.Name + (owner.Id ?? 'null')).concat(['Jointnull'])
      : ownerModel.map(owner => owner.Name + (owner.Id ?? 'null'))
    : [];

  const errorFormKey =
    errors?.bankAccount?.OwnerModel && errors?.bankAccount?.OwnerModel[index]?.Name;

  return (
    <Controller
      control={control}
      name={`bankAccount.OwnerModel.${index}.Id`}
      render={({ field: { value, onChange } }) => {
        return (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems={errorFormKey ? 'center' : 'end'}
            css={{
              gap: 8,
              flex: 1,
            }}
          >
            <Select
              css={{ flex: 1 }}
              isPortal
              value={groupOptions
                .map(({ options }) => options)
                .flat()
                .filter(option =>
                  option.value !== null
                    ? option.value === value
                    : option.label === ownerModel[index].Name,
                )}
              options={groupOptions.map(group => ({
                ...group,
                options: group.options.filter(
                  val => !selectedOwners.includes(val.label + (val.value ?? 'null')),
                ),
              }))}
              onChange={owner => {
                if (owner) {
                  onChange(owner?.value);
                  onUpdate(owner);
                }
              }}
              label={label}
              formVariant={errorFormKey && 'error'}
              helperText={errorFormKey && errorFormKey?.message}
            />
            {allowsUnequalOwnership && setCustomised && (
              <Button leftIcon="fas fa-cog" variant="secondary" onClick={setCustomised}>
                Customize
              </Button>
            )}
          </Box>
        );
      }}
    />
  );
};
